import callBackendApi from '@/apis/call';
import {
  BACKEND_RECOVERY_POLL_MS,
  markBackendUp,
} from '@australiangreens/ag-internal-components';

export const DB_RECOVERY_POLL_MS = BACKEND_RECOVERY_POLL_MS;

type StartDbRecoveryPollingOptions = {
  getAccessToken: () => Promise<string>;
  onRecovered?: () => void;
};

/** Cheap DB-only GET — SearchTemplate.checkNameClash, no Civi/Auth0 enrichment. */
async function probeDatabase(token: string): Promise<void> {
  await callBackendApi({
    token,
    method: 'get',
    endpoint: '/searchtemplates/check?name=__lm_db_probe__',
  });
}

/**
 * While the database is latched DOWN, periodically hit a cheap DB-backed GET.
 * Success clears the DB latch (hashz / unrelated successes cannot).
 */
export function startDbRecoveryPolling({
  getAccessToken,
  onRecovered,
}: StartDbRecoveryPollingOptions): () => void {
  let cancelled = false;

  const probe = async () => {
    try {
      const token = await getAccessToken();
      await probeDatabase(token);
      if (cancelled) return;
      markBackendUp({ clearDatabase: true });
      onRecovered?.();
    } catch {
      // Database still unreachable — keep polling.
    }
  };

  void probe();
  const intervalId = window.setInterval(probe, DB_RECOVERY_POLL_MS);
  return () => {
    cancelled = true;
    window.clearInterval(intervalId);
  };
}
